import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import receiveService from "./receive-srvice";
import ChangeLpn from "../change-lpn-comp.vue";
import CommonDialog from "@/components/common/common-dialog.vue";
import moment from "moment";
import PrinterDetails from "@/components/common/printer-details.vue";
import UsbAssetResults from "../usb-asset-results.vue";
import usbReceiptState from "./usb-receipt-state";
import usbAssetStatusPolling from "./usb-asset-status-polling";
import utility from "@/shared/utility";
export default {
  mixins: [usbAssetStatusPolling],
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      lableSwitchValue: true,
      lpnData: {},
      mainPage: "",
      subPage: "",
      backSlash: true,
      showMessage: false,
      showSeialDialog: false,
      showSerialMessage: "There is a mismatch in the Serial Number Entered.",
      messageContent: "",
      messageEnd: "",
      tagErrorMessage: "",
      messageStart: "",
      showStock: false,
      pageUrl: "",
      showAdd: false,
      showDialog: false,
      showSerialNumDialog: false,
      serialDialogTitle: "Serial Number Details",
      message: "",
      searchLineItem: "",
      displayAssetData: [],
      dispositionResponse: null,
      assetInfoResponse: null,
      receiptModelTracked: false,
      submittingReceipt: false,
      dispositionUpdateSucceeded: false,
      showWaybillCompleteDialog: false,
      receiptReturnPath: "",
      showAssestData: false,
      detailsKey: 0,
      receiveType: "",
      detailsData: false,
      stateData: [],
      showDetails: true,
      validateTag: false,
      showStateDrop: false,
      labelValue: true,
      showChangeLpn: false,
      resetLocation: "",
      receivingObProblem: [],
      receivingCondition: [],
      showPackingTextbox: false,
      disableSerial: false,
      menu1: false,
      showVendor: false,
      searchLPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) =>
          /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) ||
          "Enter a correct format: 000-000-000-000",
      ],
      showBillMessage:
        "You did not enter an Inbound Waybill Number. Accept Anyway?",
      serialList: [],
      searchPartNum: "",
      disableStagingLoc: false,
      RoutePartList: [],
      partResultList: [],
      disableIccid: false,
      disableEsn: false,
      showPartNum: false,
      showDiscrepancyDialog: false,
      showDiscrepancyDetails: true,
      showWarrentyData: false,
      focusField: "waybill", // Initial field to focus
      projectName: "",
      lpnObj: {},
      lineItemKey: "",
      countryData: [],
      showWaybill: true,
      reasonList: [],
      detailsList: [],
      commonHeader: [],
      tableItems: [],
      promptInfo: [],
      required: [(v) => !!v || "Field is required"],
      max36Regrex: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 36 || "Must be 36 characters or less",
        (v) => /^[a-zA-Z0-9/._ -]*$/.test(v) || "Invalid characters used",
      ],
      serialRule: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 36 || "Must be 36 characters or less",
        (v) => /^[a-zA-Z0-9/._ -]*$/.test(v) || "Invalid characters used",
      ],
      esnRule: [
        (v) => v.length <= 20 || "Must be 20 characters or less",
        (v) =>
          /^([a-zA-Z0-9/._ -]+|([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2}))$/.test(
            v
          ) ||
          "Invalid format: Only alphanumeric with / . _ - or a MAC address allowed",
      ],
      iccidRule: [
        (v) => !!v || "Field is required",
        (v) =>
          v.length === 19 ||
          v.length === 20 ||
          "Must be 19 or 20 characters long",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      max25Rule: [
        (v) => v?.length <= 25 || "Must be 25 characters or less",
        (v) => !!v || "Field is required",
      ],
      WayBillRule: [
        (v) => v?.length <= 25 || "Must be 25 characters or less",
        (v) => !!v || "Field is required",
      ],
      revisonRule: [
        (v) => !!v || "Field is required",
        (v) => v?.length <= 20 || "Maximum 20 characters allowed",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      firmWareRule: [
        (v) => !!v || "Field is required",
        (v) => v?.length <= 20 || "Maximum 20 characters allowed",
        (v) =>
          /^[a-zA-Z0-9/._ -]+$/.test(v) ||
          "Only letters, numbers, / . _ - are allowed",
      ],
      partNum: "",
      showFactoryMsg: false,
      showCraMsg: false,
      partDesc: "",
      disableCraIndex: null,
      disableBtnFactoryIndex: null,
      showWaybillDialog: false,
      unitInfo: {
        Part_key: 0,
        Session: "",
        Ware_key: 0,
        LPN: "",
        Stage_bin_key: "",
        WayBill: "",
        PackSlip: "",
        Vendor_Reference: "",
        Qty: "",
        ConditionKey: "",
        ObservedKey: "",
        BCN: "",
        SerialNo: "",
        ESN: "",
        ICCID: "",
        MSR: "",
        Fgi_scrap: "",
        Firm_Rev: "",
        lbl_size: "",
        printer_type: "",
        WarrantyEndDate: "",
      },
      detailsHeader: [
        {
          text: "Part#",
          value: "Part#",
          class: "primary customwhite--text",
        },
        {
          text: "Description",
          value: "Descrip",
          class: "primary customwhite--text",
        },
      ],
      disableEmpty: true,
      disableUnknownPart: true,
      sequence: [
        { field: "waybill", condition: true }, // Default condition is true for waybill
        { field: "packing", condition: false },
        { field: "vendor", condition: false },
        { field: "condition", condition: false },
        { field: "bcn", condition: false },
        { field: "serial", condition: false },
        { field: "esn", condition: false },
        { field: "iccid", condition: false },
        { field: "warranty", condition: false },
        { field: "revision", condition: false },
        { field: "firmware", condition: false },
        { field: "qty", condition: false },
        { field: "submit", condition: true },     
      ],
      printDisable: false,
      printerConfigured: false,
      showPrimary: true,
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = "Receiving";
    this.favouriteList = data.favouriteList;
    this.pageUrl = "receiving";
    this.subPage = `SO Receiving Details`;
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.labelValue = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
      this.lableSwitchValue = this.labelValue;
    }
    this.onChangeLabelFunction(this.labelValue);
    if (this.lableSwitchValue) {
      if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
        let Alert = {
          type: "error",
          isShow: true,
          message: "Receiving/Inventory Printer is not configured, please configure printer",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    }
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.unitInfo.WarrantyEndDate
        ? moment(String(this.unitInfo.WarrantyEndDate)).format("MM/DD/YYYY")
        : moment(String(new Date())).format("MM/DD/YYYY");
    },
  },
  async mounted() {
    this.receiptModelTracked = usbReceiptState.tracked;
    this.receiptReturnPath = usbReceiptState.returnPath || "/receiving-list-usbank/SO";
    this.unitInfo.LineId = this.lineItemKey;
    this.unitInfo.printer_type = this.primaryName;
    const lpnDetails = this.getLpnDetails();
    if (!lpnDetails) return;
    this.updateLpnState(lpnDetails);
    await this.fetchPartDetails();
    const apiResults = EncryptUtility.localStorageDecrypt("receiveUsBankApiResults");
    if (apiResults) {
      try {
        const results = JSON.parse(apiResults);
        this.dispositionResponse = results?.disposition ?? null;
        this.assetInfoResponse = results?.assetInfo ?? null;
      } catch {
        this.dispositionResponse = null;
        this.assetInfoResponse = null;
      }
    }
    if (EncryptUtility.localStorageDecrypt("receiveDisplayAssest")) {
      this.showAssestData = true;
      this.displayAssetData = JSON.parse(
        EncryptUtility.localStorageDecrypt("receiveDisplayAssest")
      );
      this.unitInfo.SerialNo = this.displayAssetData[0].value;
      this.disableSerial = true;
    
    }
    const receiveUsBankWaybill = EncryptUtility.localStorageDecrypt("receiveUsBankWaybill");
    if (receiveUsBankWaybill) {
      this.unitInfo.WayBill = receiveUsBankWaybill;
    }
    if (this.unitInfo.WayBill && this.receivingCondition?.length) {
      this.focusField = "condition";
      this.$nextTick(() => this.$refs.conditionField?.focus());
    }
  },
  methods: {
    clearTrackedReceipt() {
      usbReceiptState.reset();
      this.receiptModelTracked = false;
      this.dispositionUpdateSucceeded = false;
    },
    onConditionSelected() {
      if (this.submittingReceipt ||
        this.unitInfo.ConditionKey === "" || this.unitInfo.ConditionKey == null) return;
      this.focusNextField("condition");
    },
    async updateTrackedDisposition() {
      if (!this.receiptModelTracked || this.dispositionUpdateSucceeded) return true;
      if (!usbReceiptState.dispositionRequest) throw new Error("The original disposition request is unavailable.");
      const response = await receiveService.postUsBankGetDisposition("post", {
        ...usbReceiptState.dispositionRequest,
        update_asset: true,
      }, false);
      const errorMessage = receiveService.getUsBankDispositionError(response);
      if (errorMessage) throw new Error(errorMessage);
      const result = receiveService.getUsBankDispositionBody(response);
      if (result.result !== "passed") {
        throw new Error([result.disposition, result.detail].filter(Boolean).join(". ") || "Disposition update failed.");
      }
      this.dispositionUpdateSucceeded = true;
      this.dispositionResponse = result;
      return true;
    },
    finishWaybillReceipt(allReceived) {
      this.showWaybillCompleteDialog = false;
      const waybill = allReceived ? "" : this.unitInfo.WayBill;
      this.clearTrackedReceipt();
      usbReceiptState.nextReceipt = { waybill };
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", waybill);
      EncryptUtility.localStorageEncrypt("receiveDisplayAssest", "");
      EncryptUtility.localStorageEncrypt("receiveUsBankApiResults", "");
      this.$router.push(this.receiptReturnPath);
    },
    getLpnDetails() {
      try {
        return JSON.parse(
          EncryptUtility.localStorageDecrypt("receivelpnDetails")
        );
      } catch (error) {
        return null;
      }
    },
    updateLpnState(lpnObj) {
      this.lpnObj = lpnObj;
      Object.assign(this, {
        showReceiveLPN: Boolean(lpnObj.lpn),
        showLpnVal: lpnObj.lpn || "",
        showReceiveStaging: Boolean(lpnObj.bin),
        showReceiveStagingVal: lpnObj.bin || "",
      });
      this.projectName = this.lpnObj.projectName;
      this.unitInfo.Session = this.lpnObj.sessionId;
      this.unitInfo.ProjKey = this.lpnObj.proj_key;
      this.unitInfo.LPN = this.lpnObj.lpn;
      this.unitInfo.Stage_bin_key = this.lpnObj.stage_bin_key;
      this.lpnObj.stockRoom == "AV9B"
        ? (this.disableStagingLoc = false)
        : (this.disableStagingLoc = true);
    },
    async fetchPartDetails() {
      let partDetails = JSON.parse(
        EncryptUtility.localStorageDecrypt("receiveUsBankPartDetails")
      );
      this.detailsList = partDetails.Result.PartInfo;
      this.receivingCondition = partDetails.Result.ReceivingConInfo;
      this.sequence = [
        { field: "waybill", condition: true },
        { field: "packing", condition: this.showPackingTextbox },
        { field: "vendor", condition: this.showVendor },
        { field: "condition", condition: this.receivingCondition?.length > 0 },
        {
          field: "bcn",
          condition:
            this.detailsList[0]?.bcn_bit && !this.detailsList[0]?.auto_bcn_bit,
        },
        { field: "serial", condition: false },
        { field: "esn", condition: this.detailsList[0]?.esn_bit },
        { field: "iccid", condition: this.detailsList[0]?.iccid_bit },
        { field: "warranty", condition: this.showWarrentyData },
        { field: "revision", condition: this.detailsList[0]?.msr_bit },
        { field: "firmware", condition: this.detailsList[0]?.firm_bit },
        {
          field: "qty",
          condition: !(
            this.detailsList[0]?.bcn_bit ||
            this.detailsList[0]?.serial_bit ||
            this.detailsList[0]?.esn_bit ||
            this.detailsList[0]?.iccid
          ),
        },
        { field: "submit", condition: true },
      ];
        if (
        this.detailsList[0]?.bcn_bit ||
        this.detailsList[0]?.serial_bit ||
        this.detailsList[0]?.esn_bit ||
        this.detailsList[0]?.iccid
      ) {
        this.unitInfo.Qty = 1;
      }
    },
    onClickDialogCancelWayBill() {
      this.showWaybillDialog = false;
    },
    onClickDialogOkWaybill() {
      this.unitInfo.WayBill = "MISSING WAYBILL";
      this.showWaybillDialog = false;
    },
    onClickReceiveStagingFunction() {
      this.$router.push(`/receiving/${this.receiveType}`);
    },
    async onClickRouteToDiscrepancy() {
      this.showDiscrepancyDialog = true;
    },
    closeChangeLpnDialog(lpn) {
      if (lpn) {
        this.showLpnVal = lpn;
        this.lpnObj.lpn = lpn;
        EncryptUtility.localStorageEncrypt(
          "receivelpnDetails",
          JSON.stringify(this.lpnObj)
        );
      }
      this.showChangeLpn = false;
    },
    onClickSubmitUnitInfo() {
      if (this.submittingReceipt || this.showWaybillCompleteDialog) return;
      this.showWaybillCompleteDialog = true;
    },
    async confirmWaybillReceipt(checkIn) {
      if (this.submittingReceipt || !this.showWaybillCompleteDialog) return;
      this.showWaybillCompleteDialog = false;
      this.submittingReceipt = true;
      try {
        await this.submitReceipt(checkIn);
      } catch (error) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error", isShow: true, message: error.message || "Receipt submission failed. Please try again.",
        });
        this.focusField = "submit";
      } finally {
        this.submittingReceipt = false;
      }
    },
    async submitReceipt(checkIn) {
      const { ICCID, ESN, SerialNo, BCN, Firm_Rev } = this.unitInfo;
      const values = [ICCID, ESN, SerialNo, BCN, Firm_Rev];

      // Check for duplicate values and set focus to the appropriate field if found
      if (values?.some((val, index) => values?.indexOf(val) !== index && val)) {
        utility.showNoDataToast(
          "ICCID, ESN, Serial, Revision and BCN must be unique."
        );
        // Find the duplicate value and set focus to corresponding field
        const duplicateVal = values.find(
          (val, index) => values.indexOf(val) !== index && val
        );
        if (duplicateVal === ICCID) this.focusField = "iccid";
        else if (duplicateVal === ESN) this.focusField = "esn";
        else if (duplicateVal === SerialNo) this.focusField = "serial";
        else if (duplicateVal === BCN) this.focusField = "bcn";
        else if (duplicateVal === Firm_Rev) this.focusField = "firmware";

        return;
      }
      // Validate ProjKey
      if (!this.unitInfo.ProjKey || this.unitInfo.ProjKey === "" || this.unitInfo.ProjKey === 0) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Project Key is required and cannot be blank",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.focusField = "waybill";
        this.isSubmitting = false;  
        return;
      }
      if (this.unitInfo.WayBill == "") {
        this.showWaybillDialog = true;
        this.focusField = "waybill";
        return;
      }
      this.unitInfo.Part_key = this.detailsList[0].PartId;
      this.unitInfo.Ware_key = this.lpnObj.wareId;
      this.unitInfo.Fgi_scrap = "";
      this.unitInfo.lbl_size =
        EncryptUtility.localStorageDecrypt("primaryLabelSize");
      this.unitInfo.printer_type =
        EncryptUtility.localStorageDecrypt("primaryName");
      this.unitInfo.ObservedKey = 0;
      this.unitInfo.Part_key = this.detailsList[0].PartId;
      let validate = this.$refs.unitForm.validate();
      if (validate) {
        this.unitInfo.OrdNo = this.orderNum;
        await this.updateTrackedDisposition();
        this.unitInfo.Disposition = this.dispositionResponse?.disposition ?? "";
        this.unitInfo.CheckIn = checkIn;
        const postObj = {
          UserId: this.userId,
          json: JSON.stringify(this.unitInfo),
        };
        let apiCall = this.detailsList[0].serial_bit
          ? receiveService.postUSUnitInfoSubmit("post", postObj)
          : receiveService.postUnitInfoAction("post", postObj);
        let resp = await apiCall;
        if (resp?.Info?.HeaderInfo?.[0]?.status !== "OK") {
          throw new Error(resp?.Info?.HeaderInfo?.[0]?.message || "Receipt submission failed. Please try again.");
        }
        if (resp?.Info.HeaderInfo[0].status == "OK") {
          let Alert = {
            type: "success",
            isShow: true,
            message: "Receiving details submitted successfully",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
        if (
          resp?.Info.HeaderInfo[0].status == "OK" &&
          this.lableSwitchValue &&
          this.detailsList[0].lbl_print_bit
        ) {
          resp.Info.LabelInfo
            ? PrinterDetails.printLabelDataArray(
                resp.Info.LabelInfo,
                EncryptUtility.localStorageDecrypt("primaryName")
              )
            : "";
        }
        this.finishWaybillReceipt(checkIn);

      } else {
        utility.showNoDataToast("Please fill all required fields");

        this.unitInfo?.ESN === "" ? (this.focusField = "esn") : "";
        this.unitInfo?.ICCID === "" ? (this.focusField = "iccid") : "";
        this.unitInfo?.SerialNo === "" ? (this.focusField = "serial") : "";
        this.unitInfo?.BCN === "" &&
        this.showBCN &&
        !this.promptInfo?.auto_bcn_bit
          ? (this.focusField = "bcn")
          : "";
        this.unitInfo?.Firm_Rev === "" ? (this.focusField = "firmware") : "";

        return "";
      }
    },
    onClickReceiveLPNFunction() {
      this.showChangeLpn = true;
      this.dialogType = "LPN";
    },
    onChangeLabelFunction(value) {
      this.lableSwitchValue = value;
      EncryptUtility.localStorageEncrypt('LabelSwitchValue', JSON.stringify(this.lableSwitchValue));
    },
    receiveQuickVerificationFunction() {
      this.showChangeLpn = true;
      this.dialogType = "Verify";
    },
    onClickReceiveResetFunction(value) {
      this.showDialog = true;
      this.resetLocation = value;
      this.message = `Are you sure you want to close this receipt? You will lose any unsubmitted data?`;
    },
    onClickDialogOk() {
      this.clearTrackedReceipt();
      this.showDialog = false;
      this.resetLocation == "reset"
        ? this.$router.push("/receiving")
        : this.redirectLogic();
    },
    onClickDialogCancel() {
      this.showDialog = false;
    },
    redirectLogic() {
      this.clearTrackedReceipt();
      this.$router.go(-1);
    },
    closeDiscrepancyDialog() {
      this.showDiscrepancyDialog = false;
    },
    onClickDialogOkSerialDialog() {
      this.onClickRouteToDiscrepancy();
      this.showSeialDialog = false;
      this.disableSerial = true;
    },
    onClickDialogCancelSerialDialog() {
      this.showSeialDialog = false;
      this.disableSerial = true;
    },
    closeSerialDialog() {
      this.showSerialNumDialog = false;
    },
    async onClickSendAction(action) {
      this.clearTrackedReceipt();
      const { ICCID, ESN, SerialNo, BCN, Firm_Rev } = this.unitInfo;
      const values = [ICCID, ESN, SerialNo, BCN, Firm_Rev];
      if (values.some((val, index) => values.indexOf(val) !== index && val)) {
        utility.showNoDataToast(
          "ICCID, ESN, Serial,Revision and BCN must be unique."
        );
        return;
      }
      this.unitInfo.Part_key = this.detailsList[0].PartId;
      this.unitInfo.Ware_key = this.lpnObj.wareId;
      this.unitInfo.Fgi_scrap = action == "Scrap" ? "S" : "G";
      this.unitInfo.lbl_size =
        EncryptUtility.localStorageDecrypt("primaryLabelSize");
      this.unitInfo.printer_type =
        EncryptUtility.localStorageDecrypt("primaryName");
      if (this.$refs.unitForm.validate()) {
        this.unitInfo.Disposition = this.dispositionResponse?.disposition ?? "";
        const submitObj = {
          userId: this.userId,
          json: JSON.stringify(this.unitInfo),
        };
        let apiCall = this.detailsList[0].serial_bit
          ? receiveService.postUSUnitInfoSubmit("post", submitObj)
          : receiveService.postUnitInfoAction("post", submitObj);
        let resp = await apiCall;
        if (resp?.Info.HeaderInfo[0].status == "OK") {
          let Alert = {
            type: "success",
            isShow: true,
            message: "Receiving details submitted successfully",
          };
          if (
            resp?.Info.HeaderInfo[0].status == "OK" &&
            this.lableSwitchValue &&
            this.detailsList[0].lbl_print_bit
          ) {
            resp.Info.LabelInfo
              ? PrinterDetails.printLabelDataArray(
                  resp.Info.LabelInfo,
                  EncryptUtility.localStorageDecrypt("primaryName")
                )
              : "";
          }
          this.showMessage = true;
          this.messageStart = resp?.Info.HeaderInfo[0].start_msg;
          this.messageContent = resp?.Info.HeaderInfo[0].content_msg;
          this.messageEnd = resp?.Info.HeaderInfo[0].end_msg;
          this.$store.commit("ConfigModule/Alert", Alert);
          this.showWaybill = false;

          this.$nextTick(() => {
            this.showWaybill = true;
          });
          this.clearUnitInfo();
        }
      }
    },
        async onValidateUnitValues(pass, value) {
          // Validation checks with early returns
          if (pass === 1 && this.unitInfo.SerialNo.length === 0) {
            utility.showNoDataToast("Serial Number is empty");
            return;
          } else if (pass === 1 && this.unitInfo.SerialNo.length !== 0) {
            this.validateSerialNo();
          }
          if (pass === 2 && this.unitInfo.BCN.length === 0) {
            utility.showNoDataToast("BCN is empty");
            return;
          }
          if (pass === 3 && this.unitInfo.ESN.length === 0) {
            utility.showNoDataToast("ESN is empty");
            return;
          }
          if (pass === 4 && this.unitInfo.ICCID.length === 0) {
            utility.showNoDataToast("ICCID is empty");
            return;
          }
          const isValid = this.$refs?.iccidForm?.validate();
          if (!isValid) {
            return;
          }
          // Prepare the object for API request
          const obj = {
            UserId: this.userId ?? "",
            pass: pass,
            po_so: this.receiveType == "SO" ? "S" : "P",
            order_key: this.detailsKey ?? "",
            line_id: this.lineItemKey ?? "",
            ValidateText: value,
          };
          let resp = await receiveService.postIdentifierValidation(
            "post",
            obj,
            false
          );
          if (resp.Result.Info[0].status === "OK") {
            if (resp.Result.Info[0].setID_UI === 3) {
              this.showSeialDialog = true;
            } else if (resp.Result.Info[0].setID_UI === 2) {
              let data = resp.Result.HeaderInfo[0];
              this.serialDisplayArray = [
                { label: "Project", value: data?.project },
                { label: "Business", value: data?.business },
                {
                  label: data?.sono ? "SO Number" : "PO Number",
                  value: data?.sono || data?.custpo,
                },
                { label: "RMA", value: data?.rma },
                { label: "Request Number", value: data?.request_number },
                { label: "RITM", value: data?.RITM },
                { label: "Order Number", value: data?.ordno },
                { label: "Customer PO", value: data?.custpo },
                { label: "Order Type", value: data?.order_type },
                { label: "Company", value: data?.name, subValue: data?.company },
                { label: "Note", value: data?.note, readMore: true },
                {
                  label: "Problem Description",
                  value: data?.prob_desc,
                  readMore: true,
                },
              ];
              this.commonHeader = this.detailsHeader;
              this.tableItems = resp.Result.LineInfo;
              this.showSerialNumDialog = true;
              this.unitInfo.SerialNo = "";
              this.$refs?.unitForm?.resetValidation();
            }
            if (pass === 3) {
              this.disableEsn = true;
            }
            if (pass === 4) {
              this.disableIccid = true;
            }
          }
        },
        
    checkValidateForm(value) {
      if (this.$refs.iccidForm.validate()) {
        this.focusNextField(value);
      } else {
        this.focusField = value;
      }
    },    
    clearUnitInfo() {
      this.stopAssetStatusPolling();
      this.clearTrackedReceipt();
      this.showWaybill = false;
      this.$nextTick(() => {
        this.showWaybill = true;
      });
      let clearAll = false;
      this.detailsList[0].serial_bit ? (clearAll = false) : (clearAll = true);
      this.$refs.unitForm?.resetValidation();
      this.$refs?.iccidForm?.resetValidation();
      if (clearAll) {

        this.unitInfo = {
          WayBill: "",
          PackSlip: "",
          Vendor_Reference: "",
          Qty: "",
          ConditionKey: "",
          ObservedKey: "",
          BCN: "",
          SerialNo: "",
          ESN: "",
          ICCID: "",
          MSR: "",
          Fgi_scrap: "",
          Firm_Rev: "",
          WarrantyEndDate: "",
        };
      } else {
        this.unitInfo = {
          ...this.unitInfo,
          WayBill: "",
          PackSlip: "",
          Vendor_Reference: "",
          ConditionKey: "",
          ObservedKey: "",
          BCN: "",
          ESN: "",
          ICCID: "",
          MSR: "",
          Fgi_scrap: "",
          Firm_Rev: "",
          WarrantyEndDate: "",
        };
      }
    },
    focusNextField(currentField) {
      if (
        currentField == "serial" &&
        this.unitInfo.SerialNo.length !== 0 &&
        this.isKyndryl
      ) {
        this.validateSerialNo();
      }
      // Find the index of the current field in the sequence
      const currentIndex = this.sequence?.findIndex(
        (item) => item.field === currentField
      );

      // Find the last field with a true condition that has a visible textbox
      const activeFields = this.sequence.filter((item) => item.condition);
      const lastVisibleField = activeFields
        .filter((field) => {
          // Check for fields that have visible text inputs
          return [
            "waybill",
            "packing",
            "vendor",
            "warranty",
            "condition",
            "bcn",
            "serial",
            "esn",
            "iccid",
            "revision",
            "firmware",
            "qty",
            "discrepancy",
          ].includes(field.field);
        })
        .pop()?.field;
      // If this is the last visible field with a true condition, focus on submit button
      if (currentField === lastVisibleField) {
        this.focusField = "submit";
        // Focus on submit button and trigger click
        this.$nextTick(() => {
          const submitButton = this.$refs.submitButton;

          submitButton?.$el?.focus();
        });
        return;
      }
      // Loop through the sequence to find the next field with a true condition
      for (let i = currentIndex + 1; i < this.sequence.length; i++) {
        const nextItem = this.sequence[i];
        if (nextItem.condition) {
          this.focusField = nextItem.field;
          break;
        }
      }
    },
    // Toggle Packing Slip visibility and update sequence
    togglePackingTextbox() {
      this.showPackingTextbox = !this.showPackingTextbox;
      const packingItem = this.sequence.find(
        (item) => item.field === "packing"
      );
      if (packingItem) {
        packingItem.condition = this.showPackingTextbox;
      }
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },
    submit() {
      // Prevent default form submission
      // Actual submission is handled by onClickSubmitUnitInfo
    },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
    ChangeLpn,
    CommonDialog,
    PrinterDetails,
    UsbAssetResults,
  },
};
